import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '../core/configuration.service';


@Injectable()
export class ShareAccountService {

  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }


  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'shareaccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(shareAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'shareaccount', shareAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createWithTransactions(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'shareaccount/collect', transactionData).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  generateTransactions(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'shareaccount/generate', transactionData).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateWithTransactions(transactionData: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'shareaccount/updatewithcollect', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(shareAccount: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'shareaccount', shareAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(shareAccount: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'shareaccount/authorise', shareAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `shareaccount/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  CheckForDuplicateCustomerId(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount/duplicate/${customerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  CheckForExistingData(refund: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + `shareaccount/existingdata`, refund).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  saveShareRefund(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'shareaccount/refund', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  saveShareTransfer(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'shareaccount/transfer', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  
  calculateDividend(dividendPayableDate: string, schemeId:number,dividendFormulaId:number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount/sharedividend?dividendPayableDate=${dividendPayableDate}&schemeId=${schemeId}&dividendFormulaId=${dividendFormulaId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  payDividend(amount: number,schemeId:number,dividendPayableDate:Date,dividendFormulaId:number): Observable<any> {
    const params = {amount,schemeId,dividendPayableDate,dividendFormulaId};

    return this.httpClient.post(this.baseApiUrl + 'shareaccount/generatedividendtransaction',params).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  
  searchDividendPayable(dividendPayableDate: string, schemeId:number,dividendFormulaId:number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount/searchdividendpayable?dividendPayableDate=${dividendPayableDate}&schemeId=${schemeId}&dividendFormulaId=${dividendFormulaId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  payShareDividend(transactionData: any): Observable<any> {
 //  const params = {transactionData};

    return this.httpClient.post(this.baseApiUrl + 'shareaccount/paysharedividendtransaction',transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  
  searchShareHolders(openedDate: string, schemeId:number ): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount/searchShareHolders?openedDate=${openedDate}&schemeId=${schemeId} `).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  

  calculatesharedividend(fromMonth: number, toMonth:number ,fromYear:number,toYear:number,netProfit:number,schemeId:number,isSharePurchase:boolean ): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `shareaccount/calculatesharedividend?fromMonth=${fromMonth}&toMonth=${toMonth}&fromYear=${fromYear}&toYear=${toYear}&netProfit=${netProfit}&schemeId=${schemeId}&isSharePurchase=${isSharePurchase} `).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

 
  sharedividendpayment(transactionData: any): Observable<any> { 
    return this.httpClient.post(this.baseApiUrl + 'shareaccount/sharedividendpayment',transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  approvesharedividendpayment(transactionData: any): Observable<any> { 
       return this.httpClient.post(this.baseApiUrl + 'shareaccount/approvesharedividendpayment',transactionData).pipe(
         map((res: Response) => res),
         catchError((err: any) => observableThrowError(err.message || 'Server error')));
     }

}
